import { ImageProps } from "@commonlibs";
import clsx from "clsx";
import { ProgramImageRoot } from "./ProgramImage.styles";

function ProgramImage({ className, alt, fallback, src, ...rest }: ImageProps) {
    return <ProgramImageRoot className={clsx("program-image", className)} src={src} alt={`${alt}-img`} fallback={fallback} {...rest} />;
}

export default ProgramImage;
